<template>
  <div :class="classes">
    <m4-box v-bind="$attrs" @clickOnTitle="toggle" :class="boxClasses">
      <template v-slot:righttop>
        <m4-button @click="toggle" :variant="toggleBtnVariant" tag="a" class="box-accordion__toggle">
          <m4-icon icon="angle-down"></m4-icon>
          <span v-if="isOpened && hideTitle" class="box-accordion__toggle__title">{{ hideTitle }}</span>
          <span v-else-if="openTitle" class="box-accordion__toggle__title">{{ openTitle }}</span>
        </m4-button>
      </template>
      <slot></slot>
    </m4-box>
  </div>
</template>

<script>
export default {
  name: "M4BoxAccordion",
  data() {
    return {
      isOpened: this.opened,
      isOpenedEnd: this.opened
    };
  },
  props: {
    opened: Boolean,
    openTitle: {
      type: String,
      default() {
        return "Open";
      }
    },
    hideTitle: {
      type: String,
      default() {
        return "Hide";
      }
    },
    toggleVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    boxClasses: String
  },
  computed: {
    classes() {
      let classes = ["box-accordion"];

      if (this.isOpened) {
        classes.push("box-accordion--is-opened");
      }

      if (this.isOpenedEnd) {
        classes.push("box-accordion--is-opened-end");
      }

      return classes;
    },
    toggleBtnVariant() {
      return this.toggleVariant + "-text";
    },
    hasBodySlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;

      if (this.isOpened) {
        setTimeout(() => {
          this.isOpenedEnd = true;
        }, 300);
      } else {
        this.isOpenedEnd = false;
      }
    }
  }
};
</script>
